module.exports = __webpack_public_path__ + "static/media/dl-min.f9b6e0e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/min/dl-min.svg
// module id = 692
// module chunks = 0